import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from 'src/app/core/auth-guard.service';
import { Role } from 'src/app/models/role';

import { CreateEditSubcollectionPage } from './create-edit-subcollection.page';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuardService],
    data:{roles: [Role.Customers, Role.Buildings, Role.Projects]},
    component: CreateEditSubcollectionPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CreateEditSubcollectionPageRoutingModule {}
